<template>
    <div class="mobile-switcher" :class="rootClasses">
        <div class="mobile-switcher--element">
            <div class="mobile-switcher--element-wrap">
                <div class="mobile-switcher--active-bg"/>
                <div class="mobile-switcher--buttons">
                    <div class="mobile-switcher--button">
                        <button class="mobile-switcher--btn mobile-switcher--btn__list" @click="onClick(states.LIST)">
                            <span class="mobile-switcher--icon">
                                <ui-icon symbol="list" size="small"/>
                            </span>
                        </button>
                    </div>
                    <div class="mobile-switcher--button">
                        <button class="mobile-switcher--btn mobile-switcher--btn__map" @click="onClick(states.MAP)">
                            <span class="mobile-switcher--icon">
                                <ui-icon symbol="map" size="small"/>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { MOBILE_SWITCHER_STATES } from 'framework/vuex/modules/project-status/helpers';

    export default {
        components: {
            UiIcon,
        },
        mixins: [
            bemMixin('mobile-switcher'),
        ],
        props: {},
        data() {
            return {
                states: MOBILE_SWITCHER_STATES,
            };
        },
        computed: {
            ...mapState('project-status', ['mobileSwitcher']),
            rootClasses() {
                return [
                    this.bemAdd(`on-${ this.mobileSwitcher.toLowerCase() }`),
                    ...this.bemFacets,
                ];
            },
        },
        methods: {
            ...mapActions('project-status', ['toggleMobileSwitcher']),
            onClick(position) {
                this.toggleMobileSwitcher({ position });
            },
        },
    };
</script>
